import {
    trackPromptOpen,
    trackPromptClose,
    trackPromptSignIn,
    trackPromptRegister
} from './AuthPrompts.tracking';
import { Prompts } from './AuthPrompts.types';
import { consentNotShownInLastTenMins } from './utils/consentNotShownInLastTenMins';

export const PDP_PROMPT_EXPERIMENT =
    'crme_1094_pdp_sign_in_save_property_prompt';

export const PROMPTS: Prompts = {
    pdpTrackProperty: {
        experimentName: PDP_PROMPT_EXPERIMENT,
        title: 'Interested? Track this home’s value when you sign in or register.',
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            if (typeof window === 'undefined') return false;

            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage?.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delay: {
                time: 20
            }
        }
    }
};

export const CONSENT_COOKIE = 'cookie_consents';
